export const getActionButtonSizeAndIconSize = (textInputSize) => {
    let actionButtonSize = 's';
    let iconSize = 16;
    switch (textInputSize) {
        case 's': {
            actionButtonSize = 'xs';
            iconSize = 12;
            break;
        }
        case 'l': {
            actionButtonSize = 'm';
            break;
        }
        case 'xl': {
            actionButtonSize = 'l';
        }
    }
    return { actionButtonSize, iconSize };
};
